import React from 'react';
import { BsFillPatchCheckFill } from 'react-icons/bs';
import GitHubCalendar from "react-github-calendar"
import './experience.css';

const Experience = () => {

  // const colourTheme = {
  //   background: "#216e39",
  //   text: "#216e39",
  //   grade4: "#216e39",
  //   grade3: "#b22ff4",
  //   grade2: "#b265f6",
  //   grade1: "#c084f5",
  //   grade0: "#216e39"
  // };
  return (
    <section id="experience">
      <h5 style={{color:"#6b6767"}}> The Skills I Have</h5>
      <h2>Skills</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Front-end Development</h3>
          <div className="experience__content">
          <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>HTML</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>CSS</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>JavaScript</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>React</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Redux</h4>
            </article>
            {/* <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>SCSS</h4>
            </article> */}
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Chakra UI</h4>
            </article>
          </div>
        </div>
        <div className="experience__backend">
          <h3>Back-end Development</h3>
          <div className="experience__content">
          <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Node Js</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Express Js</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>MongoDB</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Mongoose</h4>
            </article>
            {/* <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>RSpec</h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Git/GitHub</h4>
            </article> */}
          </div>
        </div>
      </div>
      <br />
        <div className='statsDiv' style={{}}>
          <h1 className='statHead' style={{color:'var(--color-primary)', fontSize:"25px"}}>Github Stats</h1>
          <br />
          <div className='statInner' style={{width:"70%",display:"flex",justifyContentL:"space-around",alignItems:"center",margin:'auto'}}>
          {/* <img className='stat' src="https://github-readme-stats.vercel.app/api?username=Vivek-Nemade&theme=tokyonight&hide_border=true&include_all_commits=true&count_private=true" alt="" />  */}
          <img className='stat' src="https://github-readme-stats.vercel.app/api?username=vivek-nemade&show_icons=true&hide=&count_private=true&title_color=000000&text_color=6b6767&icon_color=000000&bg_color=d6d6d6&hide_border=true&show_icons=true" alt="" /> 
          {/* <img className='stat' src="https://github-stats-alpha.vercel.app/api?username=Vivek-Nemade&cc=000&tc=fff&ic=fff&bc=000" alt="" />  */}
          {/* <img className='stat' src="https://streak-stats.demolab.com?user=Vivek-Nemade&theme=city-lights&hide_border=true" alt="" />  */}
          <br />
         <img className='stat1' src="https://github-readme-streak-stats.herokuapp.com/?user=vivek-nemade&stroke=6b6767&background=d6d6d6&ring=000000&fire=000000&currStreakNum=000000&currStreakLabel=000000&sideNums=6b6767&sideLabels=6b6767&dates=6b6767&hide_border=true" alt="" />
          </div>
         
        </div>
      <div className='githubCal' style={{textAlign:"center",justifyContent:'center',marginTop:"4rem"}}>
      
        <h2 style={{marginBottom:"2rem"}}>DAYS I <span style={{color:'var(--color-primary)'}}>CODE</span> </h2>
          <div className='calendar'  style={{width:"fit-content",margin:"auto"}}>
            <GitHubCalendar username="vivek-nemade" />
          </div>
            
      </div>
    </section>
  )
}

export default Experience

// https://github-stats-alpha.vercel.app/api?username=Vivek-Nemade&cc=000&tc=fff&ic=fff&bc=000

// Where cc = Card Color
//       tc = Text Color
//       ic = Icon Color
//       bc = Border Color